import { render } from "./source-pop.vue?vue&type=template&id=0a15b6d5"
import script from "./source-pop.vue?vue&type=script&lang=js"
export * from "./source-pop.vue?vue&type=script&lang=js"

import "./source-pop.vue?vue&type=style&index=0&id=0a15b6d5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__